import { clearApiCache } from '../api/client';
// Shared in-memory cache for the Day/Today event list, so switching tabs and
// coming back is instant. Kept in its own module (not inside TodayView) so the
// EventForm can invalidate it after a create/edit/delete — otherwise a mutated
// event would keep showing the stale cached list until the next silent refetch.
export const todayEventsCache = new Map();
// Same idea for the other calendar views. Without these, every trip to Week or
// Month started from an empty screen and a spinner, even for a week you had
// just looked at — which is what made moving around the app feel slower than
// it is (the server answers in about 150 ms; the wait was self-inflicted).
export const weekEventsCache = new Map();   // 'YYYY-MM-DD' (week start) → { day: [events] }
export const monthCountsCache = new Map();  // 'YYYY-MM' → { day: count }
// Everything upcoming under one label. This is the slowest read in the app —
// it asks the provider for a whole year in one go — and it is asked for twice
// in a row by the same gesture: once by the "coming up" strip under Today's
// label filter, then again by the full label page you reach from an event.
// Cached by label id so the second one paints instantly and refreshes behind.
export const labelAgendaCache = new Map(); // subCalendarId → { label, events }

// Anyone who needs to know the moment an event changes — today only the alarm,
// which has to learn about a brand-new reminder AT ONCE rather than whenever
// its next sweep happens to come round.
const changeListeners = new Set();

/** Returns an unsubscribe function. */
export function onEventsChanged(fn) {
  changeListeners.add(fn);
  return () => changeListeners.delete(fn);
}

// Call after any event mutation so the views refetch fresh data on next mount.
// Also drops the short-lived read cache in api/client.js — otherwise a freshly
// saved event could stay hidden behind an answer received seconds earlier.
export function invalidateEventCache() {
  todayEventsCache.clear();
  weekEventsCache.clear();
  monthCountsCache.clear();
  labelAgendaCache.clear();
  // Tell the alarm straight away. It used to find out on its own three-minute
  // timer, which meant both a reminder set for two minutes' time could be
  // missed, AND a week of events being fetched twenty times a day for nothing.
  changeListeners.forEach((fn) => { try { fn(); } catch (_) {} });
  try { clearApiCache(); } catch (_) {}
}
